/**
 * Sign the current engineer out of Featurebase (messenger chats and
 * identity) on logout, as Featurebase's Messenger installation docs ask.
 * Engineers share devices, so without it the next engineer could briefly see
 * the previous one's conversations.
 *
 * Uses Featurebase's documented `Featurebase('shutdown')` command directly
 * rather than featurebase-js's `shutdown()`: that one waits 250ms, and the
 * logout page redirects straight away. Only runs when Featurebase's script is
 * already on the page, so it never loads Featurebase where it's switched off,
 * and it never throws — logout must always go through.
 */
export function shutdownFeaturebase(): void {
  try {
    if (typeof window.Featurebase === 'function') {
      window.Featurebase('shutdown')
    }
  } catch {
    // Best-effort: a Featurebase error must not block signing out.
  }
}
